export const STORAGE_KEY_PREFIX = 'teamChat.draft.';
